import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';
import { unwrapCallableData } from './callableResponse';

interface ParesCustomProductsUploadRequest {
    path: string;
    bucket: string;
    companyId: string;
    fileType: 'default' | 'akeneo' | 'pimcore';
}

interface ParesCustomProductsUploadResponse {
    companyId: string;
}

interface CallableEnvelope<T> {
    status?: 'success' | 'error';
    message?: string;
    data?: T | CallableEnvelope<T>;
}

const isObject = (value: unknown): value is Record<string, unknown> => (
    Boolean(value) && typeof value === 'object'
);

const normalizeCallableEnvelope = <T>(payload: unknown): CallableEnvelope<T> => {
    if (!isObject(payload)) return {};

    if (
        'data' in payload
        && isObject(payload.data)
        && ('status' in payload.data || 'message' in payload.data)
    ) {
        return payload.data as CallableEnvelope<T>;
    }

    return payload as CallableEnvelope<T>;
};

const parseCustomProductsUpload = async (
    path: string,
    bucket: string,
    companyId: string,
    fileType: 'default' | 'akeneo' | 'pimcore',
): Promise<ParesCustomProductsUploadResponse> => {
    const parseCustomProductsUploadCallable =
        httpsCallable<ParesCustomProductsUploadRequest, ParesCustomProductsUploadResponse>(
            functions,
            'handle_parse_custom_products_upload',
        );
    const result = await parseCustomProductsUploadCallable({
        path,
        bucket,
        companyId,
        fileType,
    });
    const payload = normalizeCallableEnvelope<ParesCustomProductsUploadResponse>(result.data);
    if (payload?.status === 'error') {
        throw new Error(payload.message || 'Upload validation failed.');
    }
    return unwrapCallableData<ParesCustomProductsUploadResponse>(result.data);
};



export { parseCustomProductsUpload };
